// import { gsap } from "gsap"
// import { ScrollTrigger } from "gsap/ScrollTrigger"
// const { $ } = window
// import { gettingStartedSlider } from "./blocks";

export default {
	init() {
      // gettingStartedSlider()

		// animateJob()
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}

function animateJob() {
	animateJobHero()
	let $hero = $('.job-hero .hero-content')
	if(!$hero.length) { return }
	gsap.from($hero, {opacity: 0, ease: 'power1.out'})
	$('.job-hero + .inner-wrap > *').each((idx, el) => {
		gsap.from(el, {
			scrollTrigger: {
				trigger: el, 
				start: 'top 90%'
			}, 
			opacity: 0, 
			ease: 'power1.out',
			delay: 0.1 * idx
		})
	})
}

function animateJobHero() {
}